
            import "data:text/css,.m-wrapper-38432db525%7Banimation-name:fade-in;animation-duration:3s%7D@keyframes%20fade-in%7B0%25%7Bopacity:0%7D75%25%7Bopacity:0%7D100%25%7Bopacity:1%7D%7D";
            const result = {"wrapper":"m-wrapper-38432db525"};
            export default result;
          